const tableOptions = {
  campaigns: {
    fields: [
      {
        id: 'id',
        label: 'pages.campaignId',
        type: 'text',
        sortable: true,
        minWidth: '50px',
        cellPaddingLeft: '24px',
        cellPaddingRight: '12px',
      },
      {
        id: 'name',
        label: 'pages.campaignName',
        type: 'text',
        sortable: true,
        minWidth: '200px',
        cellPaddingLeft: '12px',
        cellPaddingRight: '12px',
      },
      {
        id: 'type',
        label: 'pages.campaignType',
        type: 'text',
        sortable: true,
        minWidth: '50px',
        cellPaddingLeft: '12px',
        cellPaddingRight: '12px',
      },
      {
        id: 'status',
        label: 'pages.campaignStatus',
        type: 'text',
        sortable: true,
        minWidth: '50px',
        cellPaddingLeft: '12px',
        cellPaddingRight: '12px',
      },
      {
        id: 'createdAt',
        type: 'date',
        label: 'pages.createdAt',
        sortable: true,
        minWidth: '120px',
        textAlign: 'right',
        headAlign: 'right',
        cellPaddingLeft: '12px',
        cellPaddingRight: '12px',
      },
      {
        id: 'sentAt',
        label: 'pages.sentAt',
        type: 'date',
        sortable: true,
        minWidth: '120px',
        textAlign: 'right',
        headAlign: 'right',
        cellPaddingLeft: '12px',
        cellPaddingRight: '12px',
      },
      {
        id: 'audience',
        label: 'pages.audience',
        type: 'text',
        sortable: false,
        minWidth: '150px',
        cellPaddingLeft: '12px',
        cellPaddingRight: '12px',
      },
      {
        id: 'targetRecipients',
        label: 'pages.targetRecipients',
        type: 'text',
        sortable: false,
        minWidth: '50px',
        textAlign: 'right',
        headAlign: 'right',
        cellPaddingLeft: '12px',
        cellPaddingRight: '12px',
      },
      {
        id: 'receivedCount',
        label: 'pages.received',
        type: 'text',
        sortable: true,
        minWidth: '50px',
        textAlign: 'right',
        headAlign: 'right',
        cellPaddingLeft: '12px',
        cellPaddingRight: '12px',
      },
      {
        id: 'openedCount',
        label: 'pages.opened',
        type: 'text',
        sortable: true,
        minWidth: '50px',
        textAlign: 'right',
        headAlign: 'right',
        cellPaddingLeft: '12px',
        cellPaddingRight: '12px',
      },
      {
        id: 'clickedCtaCount',
        label: 'pages.clickedCTA',
        type: 'text',
        sortable: true,
        minWidth: '100px',
        textAlign: 'right',
        headAlign: 'right',
        cellPaddingLeft: '12px',
        cellPaddingRight: '12px',
      },
    ],
    rowsPerPageOptions: [5, 10, 25, 50, 100],
    filterFields: [],
    searchFields: ['id', 'name'],
  },
};

export default tableOptions;
